const STANDARD_WHITE_1 = {
  url: 'https://res.insta360.com/static/eb3c5e542c4ecaf861eabac30522ad0c/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/a97fbfceed4dcb0bbeb870e8466b70cd/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/eb3c5e542c4ecaf861eabac30522ad0c/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/ccdb4d5ffb85962c0b5509d69b38668c/01.jpg',
};
const STANDARD_BLACK_1 = {
  url: 'https://res.insta360.com/static/224e3dab4b65d410574eeb20799c3c5d/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/36c513cd03f2e00813b47d34aef4f686/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/224e3dab4b65d410574eeb20799c3c5d/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/74115404c4826ee6ab9c1c7702917f39/02-%E9%BB%91.jpg',
};
const STANDARD_2 = {
  url: 'https://res.insta360.com/static/ca008b592a8f61e44b816f6881de26e2/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/cd9c50b1e9b3ffb1335a69bd4691e533/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/ca008b592a8f61e44b816f6881de26e2/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/4dfebd41408be3008cbfb8d125d739ab/03.jpg',
};
const STANDARD_3 = {
  url: 'https://res.insta360.com/static/0f6b2ab26ca2d493b30baa5d1e3a5748/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/f08fb336df4b3c56ba9347ad395a763c/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/0f6b2ab26ca2d493b30baa5d1e3a5748/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/f4b71ea4d15c55be9e9a4d15581f212d/04.jpg',
};
const STANDARD_4 = {
  url: 'https://res.insta360.com/static/a4b3535187c9250c23255f640277f167/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/c50ce055e1d7e0f1a185c6956e144f51/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/a4b3535187c9250c23255f640277f167/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/baaadee3644bdb63e9d36a4403dceaee/05.jpg',
};
const FAMILY_WHITE_1 = {
  url: 'https://res.insta360.com/static/5fc6101109e18377997a17cce04529ea/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/ebe95d1df9e21113d9ef34bf0632abd9/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/5fc6101109e18377997a17cce04529ea/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/c645ed82cdaa48d2a5dd043bea8a72cf/01.jpg',
};
const FAMILY_BLACK_1 = {
  url: 'https://res.insta360.com/static/f118e3ee3640e25c7b382abaeb634f4d/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/cb1893e7e82e13bd96784a6bed47868e/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/f118e3ee3640e25c7b382abaeb634f4d/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/bd286d5336db3f9380355b6419e08b87/02-%E9%BB%91.jpg',
};
const FAMILY_2 = {
  url: 'https://res.insta360.com/static/bed056af3b670c110d8bf3ed60818bb2/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/8e3c4ec9aa8c77496a8f5d3007aed611/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/bed056af3b670c110d8bf3ed60818bb2/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/c479fa86d249dcd1be469c8464963b05/03.jpg',
};
const FAMILY_3 = {
  url: 'https://res.insta360.com/static/f9cd17dc27f71eba65643a1bb5bd955f/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/23ac58e56ce80bad2182a07592003bde/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/f9cd17dc27f71eba65643a1bb5bd955f/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/f590d0a2ef4d04298056277ed2eaef30/04.jpg',
};
const FAMILY_4 = {
  url: 'https://res.insta360.com/static/10d89d0c557aa48d04e3c3462a74f7b0/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/4a203e0286dd3fb458e03bccbb9567f5/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/10d89d0c557aa48d04e3c3462a74f7b0/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/5e9c040e5f60898bf8f596cc5289c552/05.jpg',
};
const ULTIMATE_WHITE_1 = {
  url: 'https://res.insta360.com/static/452302338af1067796f3aef7f2e31b04/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/c2890f42b6e2e46d61a8b9ce100be2ba/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/452302338af1067796f3aef7f2e31b04/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/bb726fc671c66736bd801b834e2cf34d/01.jpg',
};
const ULTIMATE_BLACK_1 = {
  url: 'https://res.insta360.com/static/d156e4564dd2c8c515844d8dfeca557b/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/2b99adf79478bb6538fd93f00cc23f55/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/d156e4564dd2c8c515844d8dfeca557b/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/543719ae61009ab9bb13e72769f6229e/02-%E9%BB%91.jpg',
};
const ULTIMATE_2 = {
  url: 'https://res.insta360.com/static/deee330aa523d71a54a92c5307fa4d29/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/0bb46d159420a28ed768c045a26cc66b/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/deee330aa523d71a54a92c5307fa4d29/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/750e8608131383cf20e3fb558e213f62/03.jpg',
};
const ULTIMATE_3 = {
  url: 'https://res.insta360.com/static/27de444d63fff81fdc02849fccaf7684/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/ae06ce79a478c137ca0d6996b5e76188/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/27de444d63fff81fdc02849fccaf7684/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/5fce46b6c0c547ed61fc7b80dc119edc/04.jpg',
};
const ULTIMATE_4 = {
  url: 'https://res.insta360.com/static/6f276f4993f90b37cf9e1c72b55d2697/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/fd2910ce1f1c0ffa613131f7818c6e4b/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/6f276f4993f90b37cf9e1c72b55d2697/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/1153c81a9865d56a6a64916f62cf2e6d/05.jpg',
};

const ACTION_WHITE_1 = {
  url: 'https://res.insta360.com/static/f393e8d61ef146bc195a08c5e0fb39b0/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/a2c44e83fce988dba61370b9fea1fc35/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/f393e8d61ef146bc195a08c5e0fb39b0/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/006c0b2423aeeedc2d498ebc24056bc7/01.jpg',
};
const ACTION_BLACK_1 = {
  url: 'https://res.insta360.com/static/972e4e475f9dd2d897f282471955f2b5/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/fe8e53c26986cf581789500216e4f252/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/972e4e475f9dd2d897f282471955f2b5/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/b6ae0088d0233de0c22691f46ac2c829/02-%E9%BB%91.jpg',
};
const ACTION_2 = {
  url: 'https://res.insta360.com/static/df57bc82019ad658c192f81a528dfdc2/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/7649b406752e1d76e9240162d76b96c0/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/df57bc82019ad658c192f81a528dfdc2/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/536c178893907e756a31936b2e7baf4c/03.jpg',
};
const ACTION_3 = {
  url: 'https://res.insta360.com/static/38ce5c0da11ae242eeb0a3c599728ae9/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/21a6b8d3a3edcd8f6bb842301d4a49bc/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/38ce5c0da11ae242eeb0a3c599728ae9/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/fad5e3cd72e6e95dc2c096ba63174591/04.jpg',
};

const ACTION_4 = {
  url: 'https://res.insta360.com/static/c5c7a0606ce9408dd1a84d0508102f18/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/ee484584c89a19be941e912320b6e399/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/c5c7a0606ce9408dd1a84d0508102f18/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/e5b155597c12440fd2dba6d93d4cb709/05.jpg',
};
const CREATOR_WHITE_1 = {
  url: 'https://res.insta360.com/static/1cb1f9176957089c108e48ced671d0a5/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/598b0463fcf8d3b9d23157a72dbd0b17/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/1cb1f9176957089c108e48ced671d0a5/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/c403b993b08abe2f5903f2aac636bac8/01.jpg',
};
const CREATOR_BLACK_1 = {
  url: 'https://res.insta360.com/static/dbb04ba59a53fb2f37096f9a6476ad29/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/0a327c363e63412c7e2093d07b33342e/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/dbb04ba59a53fb2f37096f9a6476ad29/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/d1ff0172bb9a32db453a691e9c304df0/02-%E9%BB%91.jpg',
};
const CREATOR_2 = {
  url: 'https://res.insta360.com/static/f070854596b9de196a1d13e3e67de070/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/6259a40ed49f637238b794f253151770/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/f070854596b9de196a1d13e3e67de070/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/65147301aa238639867d6a9dbfe7b631/03.jpg',
};
const CREATOR_3 = {
  url: 'https://res.insta360.com/static/4fab455de0ec83f23c55e09eb470d2f8/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/7595f24f8b91cc119a649480207d559b/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/4fab455de0ec83f23c55e09eb470d2f8/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/4d9eeb326bbd7383e7029ce3cc953387/04.jpg',
};
const CREATOR_4 = {
  url: 'https://res.insta360.com/static/f21a33301be0dea4264d894ce9a56085/05@2x.jpg',
  urlL: 'https://res.insta360.com/static/6809cffd5cdd325f83ec9e30d04b44f1/05@3x.jpg',
  url_m: 'https://res.insta360.com/static/f21a33301be0dea4264d894ce9a56085/05@2x.jpg',
  url_s: 'https://res.insta360.com/static/52b4a5243f31003c900dc2035644515b/05.jpg',
};
const WATER_WHITE_1 = {
  url: 'https://res.insta360.com/static/1d402197532fc66109b8ae52da0b31c5/01@2x.jpg',
  urlL: 'https://res.insta360.com/static/f3cdc045f983a1aee01675a7acb07b6e/01@3x.jpg',
  url_m: 'https://res.insta360.com/static/1d402197532fc66109b8ae52da0b31c5/01@2x.jpg',
  url_s: 'https://res.insta360.com/static/65cde603d332ee0b0286400ff8ce29f6/01.jpg',
};
const WATER_BLACK_1 = {
  url: 'https://res.insta360.com/static/b5d09312a897ea199a592f569a64d916/02-%E9%BB%91@2x.jpg',
  urlL: 'https://res.insta360.com/static/478b6859c2e8bd97586d4a66af031568/02-%E9%BB%91@3x.jpg',
  url_m: 'https://res.insta360.com/static/b5d09312a897ea199a592f569a64d916/02-%E9%BB%91@2x.jpg',
  url_s: 'https://res.insta360.com/static/2823def1a9e8f87981ec9253c7223736/02-%E9%BB%91.jpg',
};
const WATER_2 = {
  url: 'https://res.insta360.com/static/0618681f0579b7d81bed703f10a8edf1/03@2x.jpg',
  urlL: 'https://res.insta360.com/static/c3db3a2f8ba436f0694b7ae70c52216a/03@3x.jpg',
  url_m: 'https://res.insta360.com/static/0618681f0579b7d81bed703f10a8edf1/03@2x.jpg',
  url_s: 'https://res.insta360.com/static/3b386d1f2576b2cc37bc578534673fd3/03.jpg',
};
const WATER_3 = {
  url: 'https://res.insta360.com/static/494ff89a3380aee6e4c577b3bcd931ca/04@2x.jpg',
  urlL: 'https://res.insta360.com/static/a3508c3694c10ab440b11e0ffaf45d93/04@3x.jpg',
  url_m: 'https://res.insta360.com/static/494ff89a3380aee6e4c577b3bcd931ca/04@2x.jpg',
  url_s: 'https://res.insta360.com/static/617c480c42011548265d768b7ee4cc0e/04.jpg',
};

const resourcesMapperEN = new Map([
  [3125, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3135, [STANDARD_WHITE_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard white
  [3120, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3130, [STANDARD_BLACK_1, STANDARD_2, STANDARD_3, STANDARD_4]], // standard black
  [3121, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3131, [FAMILY_BLACK_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family black
  [3126, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3136, [FAMILY_WHITE_1, FAMILY_2, FAMILY_3, FAMILY_4]], // family white
  [3469, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3470, [ULTIMATE_BLACK_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate black
  [3471, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3472, [ULTIMATE_WHITE_1, ULTIMATE_2, ULTIMATE_3, ULTIMATE_4]], // ultimate white
  [3122, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3132, [ACTION_BLACK_1, ACTION_2, ACTION_3, ACTION_4]], // action black
  [3127, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3137, [ACTION_WHITE_1, ACTION_2, ACTION_3, ACTION_4]], // action white
  [3478, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3479, [CREATOR_BLACK_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator black
  [3480, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3481, [CREATOR_WHITE_1, CREATOR_2, CREATOR_3, CREATOR_4]], // creator white
  [3123, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3133, [WATER_BLACK_1, WATER_2, WATER_3]], // water black
  [3128, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
  [3138, [WATER_WHITE_1, WATER_2, WATER_3]], // water white
]);

export default resourcesMapperEN;
